import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Comment } from "app/shared/model/app.model";
import { Self } from "app/shared/model/link.model";
import { mergeMap } from "rxjs/operators";
import { CommentEntity, CommentEntityMetadata } from "./comment-list.model";

@Injectable()
export class CommentListService {
	entityMetadata!: CommentEntityMetadata;

	constructor(private http: HttpClient) {}
	
	setup(entity: CommentEntity) {
		this.entityMetadata = new CommentEntityMetadata(entity);
	}

	addComment(comment: Comment) {
		const url = this.entityMetadata.newCommentUrl,
			params = {
				comment: comment.comment,
				[this.entityMetadata.type]: this.entityMetadata.entityHref
			};
		
		return this.http.post<{ _links: Self }>(url, params).pipe(
			mergeMap(r => this.getProjectedComment(r._links.self.href))
		);
	}

	updateComment(comment: Comment) {
		const url = comment._links.self.href;

		return this.http.patch(url, { 'comment': comment.comment }).pipe(
			mergeMap(() => this.getProjectedComment(url))
		);
	}
	
	deleteComment(comment: Comment) {
		return this.http.delete<void>(comment._links.self.href);
	}

	private getProjectedComment(commentLink: string) {
		return this.http.get<Comment>(commentLink, {
			params: {
				projection: this.entityMetadata.projection
			}
		});
	}
}